import { useEffect, useRef } from 'react'
import gsap from 'gsap'
import { ScrollSmoother } from '@utils/gsap/ScrollSmoother'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { useStore } from '@Store/'
import { setSmoothScroll } from '@Store/'
import { setHideHeader, setOnBannerPosition } from '@Store/'
import { setScrollDirection } from '@Store/'
import { isDesktop } from 'react-device-detect'

gsap.registerPlugin(ScrollTrigger, ScrollSmoother)

const SmoothScroll = ({ callbacks = {} }) => {
  const [store, dispatch] = useStore()
  const { smoothScroll, scrollDirection, hideHeader, showHeaderBackground } = store

  const smoothScrollRef = useRef()
  const scrollDirectionRef = useRef()
  const showHeaderRef = useRef()
  const showHeaderBackgroundRef = useRef()
  const scrollInstanceRef = useRef(null)

  const showHeaderThreshold = 0.09
  const showHeaderBackgroundThreshold = 0.02

  useEffect(() => {
    smoothScrollRef.current = smoothScroll
  }, [smoothScroll])

  useEffect(() => {
    scrollDirectionRef.current = scrollDirection
  }, [scrollDirection])

  useEffect(() => {
    showHeaderRef.current = hideHeader
  }, [hideHeader])

  useEffect(() => {
    showHeaderBackgroundRef.current = showHeaderBackground
  }, [showHeaderBackground])

  useEffect(() => {
    setHideHeader(dispatch, false)

    const smoother = ScrollSmoother.create({
      smooth: 1.3,
      smoothTouch: false,
      effects: false,
      normalizeScroll: false,
      ignoreMobileResize: true,
      onUpdate: self => {
        const progress = self?.progress ?? 0
        const direction = self?.scrollTrigger?.direction

        if (progress > showHeaderThreshold && !showHeaderRef.current) {
          setHideHeader(dispatch, true)
        } else if (progress <= showHeaderThreshold && showHeaderRef.current) {
          setHideHeader(dispatch, false)
        }

        if (
          progress > showHeaderBackgroundThreshold &&
          !showHeaderBackgroundRef.current
        ) {
          setOnBannerPosition(dispatch, true)
        } else if (
          progress <= showHeaderBackgroundThreshold &&
          showHeaderBackgroundRef.current
        ) {
          setOnBannerPosition(dispatch, false)
        }

        if (scrollDirectionRef.current !== direction) {
          setScrollDirection(dispatch, direction)
        }
      },
    })

    scrollInstanceRef.current = smoother
    setSmoothScroll(dispatch, smoother)

    const handleStartLoading = () => {
      if (window.pathName !== window.location.pathname) {
        if (isDesktop && scrollInstanceRef.current) {
          scrollInstanceRef.current.scrollTo(1, false)
        }
        window.pathName = window.location.pathname
      }
    }

    window.addEventListener('startLoading', handleStartLoading)

    return () => {
      window.removeEventListener('startLoading', handleStartLoading)

      if (scrollInstanceRef.current) {
        scrollInstanceRef.current.kill()
        scrollInstanceRef.current = null
      }

      ScrollTrigger.clearMatchMedia()
    }
  }, [callbacks.pathname, dispatch])

  useEffect(() => {
    ScrollTrigger.refresh()
  }, [store.resized])

  return null
}

export default SmoothScroll